import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementScheduleAdded_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementScheduleAdded_ActivityLogFragment;
}

const ActivityLogTaskRequirementScheduleAdded: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.addedScheduleRequirement"
    />
  );
};

ActivityLogTaskRequirementScheduleAdded.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementScheduleAdded_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementScheduleAdded;
